<template>
	<h1 class="c-logo">
		<router-link to="/">
			<div class="c-logo__wrapper">
				<span class="c-type-delta ">My</span>
				<span class="c-type-delta c-logo__rad">Rad</span> 
				<span class="c-type-delta">Blog</span>
			</div>
			<span class="c-type-echo c-logo__tagline"><span class="c-logo__tagline-text">- Powered by VueJS &amp; Wordpress API -</span></span>
		</router-link>
	</h1>
</template>

<script>
export default {
	name: 'logo'
}
</script>



// WEBPACK FOOTER //
// logo.vue?297d31e9